module.exports = __webpack_public_path__ + "img/baseball.be51faee.svg";